import { fromJS } from 'immutable';
import ACTIONS from '../app.constants';
import { SiteActionTypes } from '../modules/site/types';

export default function siteReducer(state = fromJS({ site: {} }), action: SiteActionTypes) {
    switch (action.type) {
        case ACTIONS.GET_SITE.PENDING:
            return state.setIn(['site', 'loading'], true);
        case ACTIONS.GET_SITE.SUCCESS:
            return state.setIn(['site', 'loading'], false).setIn(['site', 'data'], action.data);
        case ACTIONS.SET_NOTIFICATION:
            return state.setIn(['site', 'notification'], {
                isError: action.data.isError || true,
                errorCode: (action.data.response && action.data.response.status) || action.data.errorCode || '',
                message:
                    action.data.message ||
                    (action.data.response && action.data.response.statusText) ||
                    action.data.message ||
                    '',
                notificationType: action.notificationType,
            });
    }

    return state;
}
